import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';
import { ObservableArray } from '@studiohyperdrive/rxjs-utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { map } from 'rxjs';

import { CypressTagDirective } from '@cjm/cypress/core';
import { VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { ButtonClasses, ImageComponent, LayoutContainerComponent } from '@cjm/shared/ui/common';
import { IconListItem, IconListComponent } from '@cjm/v-loket/shared';

import { I18nKeys } from '../../../i18n';

@Component({
	selector: 'vloket-association-passport-section',
	templateUrl: 'association-passport-section.component.html',
	styleUrls: ['association-passport-section.component.scss'],
	imports: [
		LayoutContainerComponent,
		IconListComponent,
		RouterLink,
		ImageComponent,
		AsyncPipe,
		TranslateModule,
		CypressTagDirective,
		NgxSkeletonLoaderModule,
		NgTemplateOutlet
	]
})
export class AssociationPassportSectionComponent {
	@HostBinding('class.c-association-passport-section') private readonly hasPageClass: boolean = true;

	@Input() public associationName: string;
	@Input() public associationProgress: IconListItem[];
	@Input() public associationProgressCompleted: boolean;
	@Input() public associationLoading: boolean;
	@Input() public associationError: boolean;

	public readonly buttonClasses: typeof ButtonClasses = ButtonClasses;
	public readonly appRoutePaths: typeof VLoketAppRoutePaths = VLoketAppRoutePaths;
	public readonly i18nKeys: typeof I18nKeys = I18nKeys;

	public readonly defaultAssetUrl: string = 'img/start-registration-asset.svg';
	public readonly workOnAsssetUrl: string = 'img/home/vul-je-verenigingspaspoort.svg';
	public readonly completedAssetUrl: string = 'img/home/werk-aan-je-vereniging.svg';

	public readonly items$: ObservableArray<IconListItem> = this.i18nService
		.getTranslationObservable<string[]>(I18nKeys.Home.AssociationPassportSection.DefaultList)
		.pipe(
			map((items: string[]) =>
				items.map((text: string) => ({
					icon: 'fa-check',
					iconType: 'fa-solid',
					text,
					iconClass: 'white'
				}))
			)
		);

	constructor(public readonly i18nService: NgxI18nService) {}
}
